import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cat-edit-parent',
    templateUrl: './cat-edit-parent.component.html',
    styleUrls: ['./cat-edit-parent.component.scss'],
    standalone: false
})
export class CatEditParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
